import React from 'react';
import { useTranslation } from 'react-i18next';

import ModalMC from '../../components/ModalMC';

const DeactivationModal = ({ visible, onConfirm, onCancel }) => {
  const { t } = useTranslation();

  return (
    <ModalMC
      title={t('outbound_follow_ups.deactivateTitle')}
      visible={visible}
      onClose={onCancel}
      closeOnOverlayClick
      showFooterDivider
      buttons={[
        {
          label: t('outbound_follow_ups.cancel'),
          onClick: onCancel,
          variant: 'GRAY',
        },
        {
          label: t('outbound_follow_ups.deactivateConfirm'),
          onClick: onConfirm,
          variant: 'DANGER',
        },
      ]}
      overlayClassName="tw-z-[10010]"
      containerClassName="tw-z-[10011]"
    >
      <p className="tw-text-sm tw-text-gray-600 tw-mt-2 tw-mb-4 tw-px-1">
        {t('outbound_follow_ups.deactivateWarning')}
      </p>
    </ModalMC>
  );
};

export default DeactivationModal;
